;(function ($) {
    $.fn.naturataParallax = function () {
        return $(this).each(function () {
            var container = $(this);
            if (container.has('[data-responsive-parallax]')) {
                var responsiveParallax = container.data('responsiveParallax');

                $(responsiveParallax).each(function (key, media) {
                    if (media.mediaQuery == '' || window.matchMedia(media.mediaQuery).matches) {
                        container.parallax({imageSrc: media.src});
                        return false;
                    }
                });
            } else {
                container.parallax();
            }

            container.find('[data-naturata-tabbed-content] > input[type="radio"]').on('change', function () {
                $(window).trigger('resize').trigger('scroll');
            });
        });
    };
    $(function () {
        $('[data-parallax]').naturataParallax();
    });
})(jQuery);
